import { ReactNode, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "@store/store";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import { setDialogConfig, setPopupConfig } from "@store/slices/componentsSlice";
import { useLazyGetApplicationResumeQuery } from "@services/api/applications";
import { setApplicationSelected } from "@store/slices/appSlice";

export default function Solicitud() {
    const params = useParams();
    const navigation = useNavigate();
    const dispatch = useDispatch();

    const userSession = useSelector((state: RootState) => state.app.session.user);

    const companiesUser = useSelector((state: RootState) => state.app.session.companies);

    const sectionSelected = useSelector((state: RootState) => state.components.currentSection.section);

    const [triggerGetApplications] = useLazyGetApplicationResumeQuery();

    const loadApplicationData = async () => {
        let app_data = undefined;
        let urlParams = new URLSearchParams();
        urlParams.append("q", `company_source:equals:'${params.companyName?.toUpperCase()}'`);
        urlParams.append("q", `id_application_company:equals:'${params.id}'`);

        // const companySelected = companiesUser.find((t) => t.name.toLowerCase() === params.companyName?.toLowerCase());
        // urlParams.append("company", companySelected?.id ?? "");

        companiesUser.forEach((company) => urlParams.append("company", company.id));

        const data = await triggerGetApplications(urlParams.toString()).unwrap();
        app_data = data.items.at(0);

        if (app_data === undefined) {
            navigation("/not_found");
            return;
        }

        dispatch(setApplicationSelected(app_data));
    };

    useEffect(() => {
        dispatch(setPopupConfig());
        dispatch(setDialogConfig());
    }, [sectionSelected]);

    useEffect(() => {
        loadApplicationData();
    }, [params]);

    return <Outlet />;
}
